"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsForm.titleCreate': 'Aggiungi numero telefono WhatsApp',
    'whatsapp.settingsForm.titleEdit': 'Modifica numero telefono WhatsApp',
    'whatsapp.settingsForm.back': 'Indietro',
    'whatsapp.settingsForm.loadFailed': 'Impossibile caricare la configurazione WhatsApp.',
};
